// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { IndividualConfig } from 'ngx-toastr/toastr/toastr-config';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  config: Partial<IndividualConfig> = {
    timeOut: 8000,
  };

  constructor(
    private toastr: ToastrService,
    private translateService: TranslateService,
  ) {
  }

  success(message?: string, title?: string) {
    this.toastr.success(this.translate(message), title, this.config);
  }

  error(message?: string, title?: string) {
    this.toastr.error(this.translate(message), title, this.config);
  }

  info(message?: string, title?: string) {
    this.toastr.info(this.translate(message), title, this.config);
  }

  warning(message?: string, title?: string) {
    this.toastr.warning(this.translate(message), title, this.config);
  }

  private translate(message: string) {
    return this.translateService.instant(message || 'Error');
  }
}
